import app from './global/app.json';
import error from './global/error.json';
import validation from './global/validation.json';
import test from './global/test.json';
import PFileDrop from './components/p-file-drop.json';
import PLookup from './components/p-lookup.json';
import PTable from './components/p-table.json';
import login from './pages/_exterior/login.json';
import profile from './pages/_me/profile.json';
import registration from './pages/_exterior/registration.json';
import verifyUser from './pages/_exterior/verify-user.json';
import resetPassword from './pages/_exterior/reset-password.json';
import confirmNewPassword from './pages/_exterior/confirm-new-password.json';
import appLog from './pages/_admin/applog.json';
import sequencenumbers from './pages/_admin/sequencenumbers.json';
import fieldmapping from './pages/_admin/fieldmapping.json';
import user from './pages/_admin/user.json';
import health from './pages/_admin/health.json';
import dashboard from './pages/_admin/dashboard.json';
import appAbout from './pages/_admin/app-about.json';
import integrationlog from './pages/_admin/integrationlog.json';
import contactidmapping from './pages/_admin/contactidmapping.json';
import processes from './pages/_admin/processes.json';
import error404 from './pages/error-404.json';

export default {
  core: {
    app,
    error,
    test,
    validation,
    PLookup,
    PTable,
    PFileDrop,
    page: {
      sequencenumbers,
      fieldmapping,
      processes,
      integrationlog,
      contactidmapping,
      login,
      profile,
      registration,
      verifyUser,
      resetPassword,
      confirmNewPassword,
      appLog,
      user,
      health,
      dashboard,
      appAbout,
      error404,
    },
  },
};
